<template>
  <div>404</div>
</template>

<script>
  export default {
    name: 'FourOFour',
  };
</script>

<style scoped>
  div {
    font-size: 30px;
  }
</style>
